import { Theme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';
import Profile from './Profile';
import GlobalFilter from './globalFilter';
import { LinearProgress } from '@mui/material';
import WorkflowExecutionNotifications from './workflowExecutionNotifications';
import AccessRequestNotifications from './accessRequestNotifications';
import { useGetProjectData } from 'hooks/useGetProjectData';

const HeaderContent = () => {
    const { data: projects, isLoading: projectsIsLoading } = useGetProjectData({});
    const downMD = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
    const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

    return (
        <>
            <Box
                sx={{
                    marginLeft: downLG ? 0 : 10,
                    flexShrink: 1,
                    overflow: 'hidden',
                }}>
                {projectsIsLoading ? <LinearProgress /> : <GlobalFilter projects={projects} />}
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: downMD ? 0.5 : 1,
                    flexShrink: 0,
                    ml: 'auto',
                }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <WorkflowExecutionNotifications />
                    <AccessRequestNotifications />
                </Box>

                <Profile />
            </Box>
        </>
    );
};

export default HeaderContent;
